import { Http } from './../helpers'

export const HomeService = {
  search,
  allActive,
  view,
}

function search(params) {
  return Http.get('/homes', { params: params })
}
function allActive(params) {
  return Http.get('/homes/all-active', { params: params })
}
function view(id) {
  return Http.get('/homes/' + id)
}
